import React from 'react';
import PropTypes from 'prop-types';

import FileIcon from 'components/file_system/file_icon';
import './styles.scss';

export default function AttachmentChip({ displayName, ottercon, url }) {
  return (
    <div className="attachment-chip">
      <a href={url} rel="noopener noreferrer" target="_blank">
        <FileIcon type={ottercon} />
        <span className="ml-2">
          {displayName}
        </span>
      </a>
    </div>
  );
}

AttachmentChip.propTypes = {
  displayName: PropTypes.string.isRequired,
  ottercon: PropTypes.string,
  url: PropTypes.string.isRequired,
};
